/** Public export for the invite suggestion row (SE-8313). */
export { default } from "./ShareCandidateRowContainer";
export type { ShareCandidateRowContainerProps } from "./ShareCandidateRowContainer";
